@switch (templateName) {
  @case ("selfieCamera") {
    <div class="camera-container">
      <span class="close-btn" (click)="closeCamera()">
        <i class="fa fa-close text-light fa-2x"></i>
      </span>
      <video #video autoplay muted playsinline></video>
      <span class="text-light">Ensure your face is visible</span>
      <button
        class="btn btn-light capture-btn rounded-circle"
        (click)="capture()"
      ></button>
      <canvas #canvas class="canvas-dimensions"></canvas>
    </div>
  }
  @case ("profileImageSetTemplate") {
    <div class="dialog-box card p-2">
      <div class="card-header">Profile Picture Updated</div>
      <div class="my-3 text-center">
        Your profile picture has been updated, you can change this at any time
        from your user profile settings.
      </div>
      <div class="col my-3">
        <button
          type="button"
          class="btn btn-primary btn-lg w-100"
          (click)="closeDailogBox(false)"
        >
          Ok
        </button>
      </div>
    </div>
  }
  @case ("faceComparisonFaledTemplate") {
    <div class="dialog-box card p-2">
      <div class="card-header">Action Unsuccessful</div>
      <div class="mb-5 text-center">
        <p>Facial recognition failed, please try again.</p>
      </div>
      <div class="row row-cols-2">
        <div>
          <button
            type="button"
            class="btn btn-secondary btn-lg w-100"
            (click)="closeDailogBox(false)"
          >
            Ignore
          </button>
        </div>
        <div>
          <button
            type="button"
            class="btn btn-primary btn-lg w-100"
            (click)="closeDailogBox(true)"
          >
            Retry
          </button>
        </div>
      </div>
    </div>
  }
}
